export const SET_PAYOUTS = "PAYOUTS_SET_PAYOUTS";
export const SET_ERROR = "PAYOUTS_SET_ERROR";
export const SET_FETCHING = "PAYOUTS_SET_FETCHING";
